import { Flex, Modal, ModalBody, ModalContent, ModalOverlay, Text, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { Button, type ButtonProps } from "ui/button";
import { desktopOnlyDisplay } from "utils";
import { type FormProps, HubSpotForm } from "./hubspot-form";

type HubSpotFormModalProps = {
  modalHeading: string;
  modalDescription?: string;
  modalLabel?: string;
  hasLaunchButtonChevron?: boolean;
  launchButtonVariant?: ButtonProps["variant"];
  launchButtonPulse?: ButtonProps["pulse"];
};

export function HubSpotFormModal({
  label,
  modalHeading,
  modalDescription,
  modalLabel,
  hasLaunchButtonChevron,
  launchButtonVariant,
  launchButtonPulse,
  ...formProps
}: FormProps & HubSpotFormModalProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        hasRightChevron={hasLaunchButtonChevron}
        variant={launchButtonVariant}
        pulse={launchButtonPulse}
        onClick={onOpen}
      >
        {label}
      </Button>

      <Modal isCentered isOpen={isOpen} size="lg" onClose={onClose}>
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(8px)" />

        <ModalContent borderRadius={{ base: "base", md: "big" }} m="smallest">
          <ModalBody p={{ base: "big", md: "bigger" }}>
            <Flex flexDir="column" gap="smaller" mb="small">
              <Text as="h2" textStyle={{ base: "headline3", md: "headline2" }}>
                {modalHeading}
              </Text>
              <Text textStyle="body3" color="brand.textSecondary.light" display={desktopOnlyDisplay()}>
                {modalDescription}
              </Text>
            </Flex>

            <HubSpotForm label={modalLabel ?? label} {...formProps} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
